import { api } from '@/shared/api/client';
import type { AuthTokens, SignInRequest } from '../model/dto';

export const postAuthSignIn = async (payload: SignInRequest) => {
  const { data } = await api.post<AuthTokens>('/auth/signin/', payload);
  return data;
};
